import { AgentDesktopRouter } from '@agent/agent-interface/agent-desktop-router';
import { AgentDesktopRouteParams } from '@agent/agent-interface/agent-desktop-routing.module';
import { Component, Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { default as componentAjs } from './agent-booking-phone-inprocess-conference.component.ajs';

@Directive({
  selector: 'cng-agent-booking-phone-inprocess-conference-upgrade',
})
export class AgentBookingPhoneInprocessConferenceUpgradeComponent extends UpgradeComponent {
  @Input() responseId: string;
  @Input() guestId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-agent-booking-phone-inprocess-conference',
  template:
    '<cng-agent-booking-phone-inprocess-conference-upgrade [responseId]="responseId$ | async" [guestId]="guestId$ | async"></cng-agent-booking-phone-inprocess-conference-upgrade>',
})
export class AgentBookingPhoneInprocessConferenceComponent {
  readonly responseId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.ResponseId.select);
  readonly guestId$ = this.router.currentSnapshot$.pipe(AgentDesktopRouteParams.GuestId.select);

  constructor(private readonly router: AgentDesktopRouter) {}
}
